// extracted by mini-css-extract-plugin
export var darkMode = "_q-0";